import * as React from 'react';
import * as TypeStyle from 'typestyle';
import { TabStyles } from '../../styles/TabStyles';
import { makeTestId } from '../../utils/Declarative';

const FooterStyleName = TypeStyle.style({
  height: 48,
  flexShrink: 0,
});

const FooterContentStyleName = TypeStyle.style({
  height: '100%',
});

export const DialogFooter: React.FunctionComponent<{ sidePadding: number, testId: string }> = props =>
  <div
    className={FooterStyleName}
    data-tb-test-id={makeTestId(props.testId, 'Footer')}
    style={{ padding: `0 ${props.sidePadding}px` }}
  >
    {props.children && <div className={FooterContentStyleName} children={props.children} />}
  </div>;
DialogFooter.displayName = 'DialogFooter';
DialogFooter.defaultProps = { sidePadding: TabStyles.Spacing.LargeSpace };
